@if (toastService.toasts().length > 0) {
    @for (toast of toastService.toasts(); track toast) {
        <ngb-toast class="{{ styleClass(toast) }}" [autohide]="true" [delay]="toast.delay || 5000" [hidden]="hidden" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-content-wrapper">
                <i class="icon {{ iconClass(toast) }}" aria-hidden="true"></i>
                <div class="toast-content">
                    @if (toast.heading) {
                        <div class="toast-heading">{{ toast.heading }}</div>
                        <div class="toast-message">{{ toast.message }}</div>
                    } @else {
                        <div class="toast-message">{{ toast.message }}</div>
                    }
                </div>
                <button type="button" class="btn-close btn-close-white ms-auto" aria-label="Close" (click)="close(toast)"></button>
            </div>
        </ngb-toast>
    }
}
